export default function scrollReveal() {
    const cards = document.querySelectorAll('.gh-postfeed .gh-card');
    if (!cards.length) return;

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Add the reveal class to all cards (hides them)
    cards.forEach(function(card) {
        card.classList.add('gh-reveal');
    });

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('gh-revealed');
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '50px',
        threshold: 0.1
    });

    cards.forEach(function(card) {
        observer.observe(card);
    });
}
